import instance, { ADMIN_PREFIX } from 'services/api';
import {
  FinancialChartsQuery,
  FinancialChartsResponse,
  FinancialReportListResponse,
  FinancialReportQuery
} from 'types/api/financial';

/**
 * GET /api/v2/admin/appointments/financial-report
 *
 * BE pagination is 1-based (DTO @Min(1)). The FE caller works in
 * 0-based pages (matches the legacy GQL pagination + URL search-params),
 * so the service coerces here.
 */
export const fetchFinancialReport = async (
  query: FinancialReportQuery
): Promise<FinancialReportListResponse> => {
  const params: Record<string, string | number | boolean> = {
    page: query.page ?? 1,
    limit: query.limit ?? 10
  };

  if (query.name) params.name = query.name;
  if (query.paid !== undefined) params.paid = query.paid;
  if (query.from) params.from = query.from;
  if (query.to) params.to = query.to;
  if (query.organizationId !== undefined)
    params.organizationId = query.organizationId;

  const res = await instance.get<FinancialReportListResponse>(
    `${ADMIN_PREFIX}/appointments/financial-report`,
    { params }
  );

  return {
    results: res.data.results ?? [],
    total: res.data.total ?? 0
  };
};

export const fetchFinancialCharts = async (
  query: FinancialChartsQuery
): Promise<FinancialChartsResponse> => {
  const res = await instance.get<FinancialChartsResponse>(
    `${ADMIN_PREFIX}/appointments/financial-charts`,
    { params: query }
  );

  return res.data;
};
